export default "__VITE_ASSET__c45d04d4__"